import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import GalleryContent from '../sections/GalleryContent/GalleryContent';

const GalleryPage = () => {
    
    return (
        <>
            <Navbar />
            <GalleryContent />
            <Footer />
        </>
    );
};

export default GalleryPage;